export const deprecationWarning = (isInUse = false, message = '') => {
    if (isInUse)
        console.warn(`[Deprecation]: ${message}`);
};
//# sourceMappingURL=deprecation-warning.js.map